module.exports = "<div class=\"container\" style=\"width: 450px; margin-top: 5%;\">\n  <h2 class=\"s-page-title\" style=\"margin-left: 10px;\">ERROR 404: PAGE NOT FOUND</h2>\n    <div class=\"row mb2\">\n        <div class=\"col\">\n            <p><img style=\"max-width: 400px;\" src=\"./assets/images/error404.gif\"></p>\n            <h4 style=\"margin-left: 40px;\">Go back to <a href=\"/\">ADLUUX home page</a>!</h4>\n\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/error404/error404.component.html
// module id = ../../../../../src/app/pages/error404/error404.component.html
// module chunks = main